export default __webpack_public_path__ + "static/media/logo.74a72d8b.svg";